import { render } from "./AuthPageIntro.vue?vue&type=template&id=79b09112"
import script from "./AuthPageIntro.vue?vue&type=script&lang=js"
export * from "./AuthPageIntro.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__